export default {
  settings: {
    title: "Настройки",
    form: {
      fastRun: "Быстрый запуск",
      fastRunOptions: {
        classic: "Классический",
        basic: "Базовый",
        user: "Пользовательский"
      }
    },
    notify: {
      title: "Быстрый запуск",
      message: "Настройки успешно сохранены"
    }
  }
};
